module.exports = __webpack_public_path__ + "static/media/user.ecf3a8fb.csv";